import { FunctionComponent, useEffect } from 'react';
import { BlockerFunction } from 'react-router';
import ReactRouterPrompt from 'react-router-prompt';
import { useModal } from '../modal/useModal';
import { UnsavedChangesModal } from './UnsavedChangesModal';

interface UnsavedChangesProps {
  show: BlockerFunction | boolean;
}

const UnsavedChanges: FunctionComponent<UnsavedChangesProps> = ({ show }) => {
  const confirmModalProps = useModal();

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (show) {
        event.preventDefault();
        event.returnValue = ''; // This triggers the browser's confirmation dialog
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [show]);

  return (
    <ReactRouterPrompt when={show}>
      {({ isActive, onConfirm, onCancel }) => {
        const { isOpen, ...rest } = confirmModalProps;

        return (
          <UnsavedChangesModal isOpen={isActive} onCancelCallback={onCancel} onConfirmCallback={onConfirm} {...rest} />
        );
      }}
    </ReactRouterPrompt>
  );
};

export default UnsavedChanges;
